// extracted by mini-css-extract-plugin
export default {"accodions":"style_accodions__vYWwW","title":"style_title__ujNcd","items":"style_items__F08E9","item":"style_item__BmWbQ"};